import {Component, Injector, Input} from '@angular/core';
import {DialogBaseComponent} from "../../../../base-admin-panel/dialog-base/dialog-base.component";
import { InputViewModel, TrendBindingHistory, TrendViewModel } from '../../../Models/TrendViewModel';

@Component({
    selector: 'app-trend-binding-history',
    templateUrl: './trend-binding-history.component.html',
    styleUrls: ['./trend-binding-history.component.css'],
    standalone: false
})
export class TrendBindingHistoryComponent extends DialogBaseComponent<TrendViewModel>
{
  @Input()
  public Inputs: InputViewModel[] = [];

  inputNumber: number = 0;


  constructor(protected injector: Injector) {
    super(injector);

    this.dialogId = "trendBindingHistoryManagement";
  }

  submit(): void
  {
    
    super.submit();
  }

  public getInputName(input: string) {
    let inputNumber = 0;
    let matches = input.match(/\d+$/);
    if (matches) {
      inputNumber = parseInt(matches[0], 10);
      input = input.replace(matches[0], "")
    }
    let foundInput = this.Inputs.find(i => i.Id == input);
    if (!foundInput)
      return input;
    if (foundInput.AvailableNumbers > 0)
      return this.translate.instant(foundInput.Name) + " " + inputNumber;
    return this.translate.instant(foundInput.Name);
  }
  public addLine() {
    var newline = new TrendBindingHistory();
    newline.Time = (new Date()).getTime();
    this.model.TrendBindingHistory.push(newline);
  }
  public deleteBinding(binding: TrendBindingHistory)
  {
    for (var i = 0; i < this.model.TrendBindingHistory.length; i++)
      if (binding.Time == this.model.TrendBindingHistory[i].Time)
      {
        this.model.TrendBindingHistory.splice(i, 1);
        break;
      }
  }
  public getCalendarName(binding: TrendBindingHistory)
  {
    for (var i = 0; i < this.model.TrendBindingHistory.length; i++)
      if (binding.Time == this.model.TrendBindingHistory[i].Time)
        return "calendar" + i;
  }
  getMaxInputNumber(binding: TrendBindingHistory) {
    let input = this.Inputs.find(i => i.Id == binding.Input);
    if (!input) return 0;
    return input.AvailableNumbers;
  }
}
